function openCartDrawer() {
    document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
    document.querySelector("body").classList.add("cart-drawer--visible");
  }
  
  function closeCartDrawer() {
    document.querySelector(".cart-drawer").classList.remove("cart-drawer--active");
    document.querySelector("body").classList.remove("cart-drawer--visible");
  }
  
  function updateCartItemCounts(count) {
    document.querySelectorAll(".CartCount").forEach((el) => {
      el.textContent = count;
    });
  }
  
  async function updateCartDrawer() {
    console.log('entre a update cart')
    const res = await fetch("/?section_id=cart-drawer");
    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;
  
    const newBox = html.querySelector(".cart-drawer").innerHTML;
  
    document.querySelector(".cart-drawer").innerHTML = newBox;
  
    addCartDrawerListeners();
    removeCartItems();
  }
  
  function removeCartItems() {
    document
    .querySelectorAll(".remove__item")
    .forEach((e) => {
      e.addEventListener("click", async () => {
        const rootItem =
            e.parentElement.parentElement.parentElement.parentElement
        const key = rootItem.getAttribute("data-line-item-key");
  
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: 0 } }),
        });
        const cart = await res.json();
  
        updateCartItemCounts(cart.item_count);
  
        // Update cart
        updateCartDrawer();
  
      });
    });
  }
  
  function addCartDrawerListeners() {
    // Update quantities
    document
      .querySelectorAll(".cart-drawer-quantity-selectors")
      .forEach((button) => {
        button.addEventListener("click", async () => {
          // Get line item key
          const rootItem =
            button.parentElement.parentElement.parentElement.parentElement
            .parentElement.parentElement.parentElement
          const key = rootItem.getAttribute("data-line-item-key");
  
          // Get new quantity
          const currentQuantity = Number(
            button.parentElement.parentElement.querySelector("input").value
          );

          const isUp = button.classList.contains(
            "cart-drawer-quantity-selector-plus"
          );
          const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;
  
          // Ajax update\
          const res = await fetch("/cart/update.js", {
            method: "post",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates: { [key]: newQuantity } }),
          });
          const cart = await res.json();
  
          updateCartItemCounts(cart.item_count);
  
          // Update cart
          updateCartDrawer();
        });
      });
  
    document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
      e.stopPropagation();
    });
  
    document
      .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
      .forEach((el) => {
        el.addEventListener("click", () => {
          console.log("closing drawer");
          closeCartDrawer();
        });
      });

    
  document.querySelectorAll('.cart-x-sell-item-add').forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const variantId = button.getAttribute('data-variant-id');
      let formData = {
        'items': [{
        'id': variantId,
        'quantity': 1
        }]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        updateCartDrawer();
        console.log('response', response)
      })

      .catch((error) => {
        console.error('Error:', error);
      });
    })
  })
  }
  
  addCartDrawerListeners();
  removeCartItems();
  

  document.querySelectorAll('.Button-Add').forEach((form) => {
    form.addEventListener("click", async (e) => {
      e.preventDefault();

      // Get cart count
      const res = await fetch("/cart.js");
      const cart = await res.json();
      console.log('esto es carrito', cart)  
      updateCartItemCounts(cart.item_count);  

      // Update cart
        await updateCartDrawer();
        console.log('actualice carrito')

        // Open cart drawer
        openCartDrawer();
    });
  });

  document.querySelectorAll('.js-product-add-to-cart-button').forEach((form) => {
    form.addEventListener("click", async (e) => {
      e.preventDefault();

      // Get cart count
      const res = await fetch("/cart.js");
      const cart = await res.json();
      console.log('esto es carrito', cart) 
         
      updateCartItemCounts(cart.item_count);  

      setTimeout(async () => {
      // Update cart
        await updateCartDrawer();
        console.log('actualice carrito')

       // Open cart drawer
        openCartDrawer();
      }, 800);

    });
  });





  
  iconCart = document.querySelectorAll('.openCartDrawer').forEach((button) => {
    button.addEventListener("click", (e) => {
     e.preventDefault();
      openCartDrawer();
    })
  })
